import { render, staticRenderFns } from "./ScrollDownArrow.vue?vue&type=template&id=2500db84&scoped=true&"
import script from "./ScrollDownArrow.vue?vue&type=script&lang=js&"
export * from "./ScrollDownArrow.vue?vue&type=script&lang=js&"
import style0 from "./ScrollDownArrow.vue?vue&type=style&index=0&id=2500db84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../rebuild/huang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500db84",
  null
  
)

export default component.exports